const SORT_DIRECTIONS = {
  ASCENDING: '1',
  DESCENDING: '-1',
};

export const SORT_OPTIONS = {
  NEWEST_FIRST: {
    value: 'createdAt',
    direction: SORT_DIRECTIONS.DESCENDING,
    label: 'Newest first',
  },
  OLDEST_FIRST: {
    value: 'createdAt',
    direction: SORT_DIRECTIONS.ASCENDING,
    label: 'Oldest first',
  },
  EMAIL_ASCENDING: {
    value: 'customerEmail',
    direction: SORT_DIRECTIONS.ASCENDING,
    label: 'Email A-Z',
  },
  EMAIL_DESCENDING: {
    value: 'customerEmail',
    direction: SORT_DIRECTIONS.DESCENDING,
    label: 'Email Z-A',
  },
};

export const FILTER_OPTIONS = {
  ALL: {
    label: 'All',
    value: 'all',
  },
  ACTIVE: {
    label: 'Active',
    value: 'active',
  },
  RECOVERED: {
    label: 'Recovered',
    value: 'recovered',
  },
  TRIALING: {
    label: 'Trialing',
    value: 'trialing',
  },
  SCHEDULED: {
    label: 'Scheduled',
    value: 'scheduled',
  },
  COMPLETED: {
    label: 'Completed',
    value: 'completed',
  },
  CANCELED: {
    label: 'Canceled',
    value: 'canceled',
  },
  PAST_DUE: {
    label: 'Overdue',
    value: 'past_due',
  },
  INCOMPLETE: {
    label: 'Incomplete',
    value: 'incomplete',
  },
  FAILED: {
    label: 'Failed',
    value: 'failed',
  },
  ABANDONED: {
    value: 'abandoned',
    label: 'Abandoned',
  },
};

export const COUPON_FILTER_OPTIONS = {
  ALL: {
    label: 'All',
    value: 'all',
  },
  ACTIVE: {
    label: 'Active',
    value: 'active',
  },
  RECOVERED: {
    label: 'Recovered',
    value: 'recovered',
  },
  TRIALING: {
    label: 'Trialing',
    value: 'trialing',
  },
  SCHEDULED: {
    label: 'Scheduled',
    value: 'scheduled',
  },
  COMPLETED: {
    label: 'Completed',
    value: 'completed',
  },
  CANCELED: {
    label: 'Canceled',
    value: 'canceled',
  },
  PAST_DUE: {
    label: 'Overdue',
    value: 'past_due',
  },
};

export function getSortOptionFromQuery(sortBy, sortDirection) {
  const sortOption = Object.keys(SORT_OPTIONS).find(
    key => SORT_OPTIONS[key].value === sortBy && SORT_OPTIONS[key].direction === sortDirection,
  );

  return sortOption || Object.keys(SORT_OPTIONS)[0];
}

export function getStatusFromQuery(status) {
  const statusOption = Object.keys(FILTER_OPTIONS).find(
    key => FILTER_OPTIONS[key].value === status,
  );

  return statusOption || Object.keys(FILTER_OPTIONS)[0];
}
